import { inject, Injectable } from '@angular/core';
import { SeuLanguage, SeuUserProfile } from '@seu-types';
import { UserProfileRestControllerApiService } from '../api';
import { StoreService } from './store.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly userProfileRestControllerApiService = inject(
    UserProfileRestControllerApiService
  );
  private readonly toastService = inject(ToastService);
  private readonly store = inject(StoreService);

  public async fetchUserProfile(): Promise<SeuUserProfile | null> {
    return new Promise<SeuUserProfile | null>((resolve) => {
      this.userProfileRestControllerApiService.getUserProfile().subscribe({
        next: (profile) => {
          const userProfile = {
            ...profile,
            preferredLanguage: profile.preferredLanguage?.toUpperCase(), // temp fix, cause backend is returning lower case lang codes
          } as SeuUserProfile;
          this.store.setUserProfile(userProfile);
          resolve(userProfile);
        },
        error: () => {
          this.toastService.addToast({
            type: 'error',
            text: 'user-profile.toasts.get-error',
          });

          resolve(null);
        },
      });
    });
  }

  /**
   * Updates the user profile. Currently mocked until backend implements PUT /user/profile endpoint.
   * Once backend is ready, this should use userProfileRestControllerApiService.updateUserProfile()
   */
  public async updatePreferredLanguage(lang: SeuLanguage): Promise<void> {
    return new Promise<void>((resolve) => {
      this.userProfileRestControllerApiService
        .updatePreferredLanguage({ body: lang })
        .subscribe({
          next: () => {
            const profile = this.store.getUserProfile();
            if (!profile) {
              return;
            }

            this.store.setUserProfile({ ...profile, preferredLanguage: lang });
            resolve();
          },
          error: () => {
            this.toastService.addToast({
              type: 'error',
              text: 'user-profile.toasts.update-error',
            });

            resolve();
          },
        });
    });
  }
}
